// extracted by mini-css-extract-plugin
export default {"section":"LandingFaq_section__QONZp","container":"LandingFaq_container__dQ8sN","faq-button":"LandingFaq_faq-button__zlw7Z"};